import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Fundcode(state = initialState, action) {
  switch (action.type) {
    case userConstants.FUNDCODE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.FUNDCODE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.FUNDCODE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}